<template>
    <div class="d-flex align-items-center w-100" v-b-tooltip.hover :title="tooltipText">
        <div class="w-75 pr-1">
            <b-progress :value="progressValue" :variant="progressVariant" style="height: 12px" max="100" />
        </div>

        <div class="w-25 text-right text-nowrap">
            <small class="font-weight-bolder pr-1">{{ displayText }}</small>
        </div>
    </div>
</template>

<script>
import { BProgress, VBTooltip } from "bootstrap-vue";

export default {
    components: { BProgress },
    directives: { "b-tooltip": VBTooltip },
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
    computed: {
        tooltipText() {
            const { TotalItemCount, SuccessItemCount, FailedItemCount } = this.row;
            const processed = SuccessItemCount + FailedItemCount;
            return `Toplam: ${TotalItemCount} | İşlenen: ${processed} | Başarılı: ${SuccessItemCount} | Hatalı: ${FailedItemCount}`;
        },
        displayText() {
            const { TotalItemCount, SuccessItemCount, FailedItemCount } = this.row;
            const processed = SuccessItemCount + FailedItemCount;
            return `${processed}/${TotalItemCount}`;
        },
        progressVariant() {
            if (this.row.FailedItemCount > 0) return "danger";
            if (this.row.Status === "Success") return "success";
            if (this.row.Status === "InProgress") return "info";
            return "secondary";
        },
        progressValue() {
            if (this.row.TotalItemCount === 0) return 0;
            const processedCount = this.row.SuccessItemCount + this.row.FailedItemCount;
            return (processedCount / this.row.TotalItemCount) * 100;
        },
    },
};
</script>
